import React from 'react';
import { LuminousBreakLogo } from './LuminousBreakLogo';
import { TermsOfServiceContent } from './LegalModals';

interface TermsOfServicePageProps {
  onNavigateHome?: () => void;
  onNavigatePrivacy?: () => void;
  onNavigateSupport?: () => void;
}

export const TermsOfServicePage: React.FC<TermsOfServicePageProps> = ({
  onNavigateHome,
  onNavigatePrivacy,
  onNavigateSupport,
}) => {
  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#FAF8F5',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      color: '#2D2826',
      display: 'flex',
      flexDirection: 'column',
    }}>
      {/* Top Header */}
      <header style={{
        backgroundColor: '#FFFFFF',
        borderBottom: '1px solid #EAE0D5',
        padding: '16px 24px',
        position: 'sticky',
        top: 0,
        zIndex: 100,
      }}>
        <div style={{
          maxWidth: '1000px',
          margin: '0 auto',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '12px',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
            <div
              onClick={onNavigateHome}
              style={{ cursor: onNavigateHome ? 'pointer' : 'default', display: 'flex', alignItems: 'center' }}
            >
              <LuminousBreakLogo size={32} showText={true} />
            </div>
          </div>
          <nav style={{ display: 'flex', alignItems: 'center', gap: '16px', fontSize: '13px' }}>
            {onNavigateHome ? (
              <button
                onClick={onNavigateHome}
                style={{
                  background: 'none',
                  border: '1px solid #CBD5E1',
                  borderRadius: '6px',
                  padding: '6px 12px',
                  color: '#475569',
                  cursor: 'pointer',
                  fontWeight: 500,
                }}
              >
                ← Back to Home
              </button>
            ) : (
              <a
                href="/"
                style={{
                  textDecoration: 'none',
                  border: '1px solid #CBD5E1',
                  borderRadius: '6px',
                  padding: '6px 12px',
                  color: '#475569',
                  fontWeight: 500,
                }}
              >
                ← Back to Home
              </a>
            )}
            {onNavigatePrivacy ? (
              <button
                onClick={onNavigatePrivacy}
                style={{ background: 'none', border: 'none', color: '#2563EB', cursor: 'pointer', textDecoration: 'underline' }}
              >
                Privacy Policy
              </button>
            ) : (
              <a href="/privacy" style={{ color: '#2563EB', textDecoration: 'underline' }}>
                Privacy Policy
              </a>
            )}
            {onNavigateSupport ? (
              <button
                onClick={onNavigateSupport}
                style={{ background: 'none', border: 'none', color: '#2563EB', cursor: 'pointer', textDecoration: 'underline' }}
              >
                Support & Contact
              </button>
            ) : (
              <a href="/support" style={{ color: '#2563EB', textDecoration: 'underline' }}>
                Support & Contact
              </a>
            )}
            <a
              href="/terms.md"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: '#64748B', textDecoration: 'underline', fontSize: '12px' }}
            >
              Raw Markdown (.md)
            </a>
          </nav>
        </div>
      </header>

      {/* Main Content Area */}
      <main style={{
        flex: 1,
        maxWidth: '900px',
        width: '100%',
        margin: '32px auto',
        padding: '0 20px',
        boxSizing: 'border-box',
      }}>
        <div style={{
          backgroundColor: '#FFFFFF',
          borderRadius: '16px',
          border: '1px solid #E2E8F0',
          boxShadow: '0 4px 16px rgba(0, 0, 0, 0.04)',
          padding: '40px',
        }}>
          <h1 style={{
            fontSize: '28px',
            fontWeight: 800,
            color: '#1E293B',
            marginTop: 0,
            marginBottom: '16px',
            letterSpacing: '-0.5px',
          }}>
            Luminous Break Terms of Service
          </h1>
          <TermsOfServiceContent />
        </div>
      </main>

      {/* Footer */}
      <footer style={{
        backgroundColor: '#FFFFFF',
        borderTop: '1px solid #E2E8F0',
        padding: '24px',
        textAlign: 'center',
        fontSize: '12px',
        color: '#64748B',
      }}>
        <p style={{ margin: 0 }}>
          © 2026 Luminous Break Inc. All rights reserved. • 500 Howard Street, Suite 400, San Francisco, CA 94105
        </p>
      </footer>
    </div>
  );
};
